import './MicOverlay.css';

/**
 * Shown the first time a user taps the mic in this browser profile, before
 * the OS-level permission prompt fires. Sets expectations so the browser
 * dialog doesn't feel like it's coming out of nowhere.
 */

interface MicPrePromptProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function MicPrePrompt({ open, onConfirm, onCancel }: MicPrePromptProps) {
  if (!open) return null;
  return (
    <div
      className="mic-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="mic-pre-prompt-title"
    >
      <div className="mic-overlay__backdrop" onClick={onCancel} />
      <div className="mic-overlay__card">
        <p className="mic-overlay__eyebrow">Microphone access</p>
        <h2 id="mic-pre-prompt-title" className="mic-overlay__title">
          About to ask your browser for the mic.
        </h2>
        <p className="mic-overlay__body">
          We use your microphone only while you&apos;re actively in a session — your voice goes to
          the avatar so it can respond, and to the transcript so you can review it later. Nothing is
          recorded outside the session.
        </p>
        <ul className="mic-overlay__points">
          <li>Tap to start, tap to stop. Always your call.</li>
          <li>Type instead any time — text input stays available.</li>
        </ul>
        <div className="mic-overlay__actions">
          <button type="button" className="mic-overlay__btn-ghost" onClick={onCancel}>
            Not now
          </button>
          <button type="button" className="mic-overlay__btn-primary" onClick={onConfirm}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
